export const CONTENT_PUSH_INTENT_KEYS = Object.freeze({
  tasks: "tb_public_web_content_push_intent_v2:tasks",
  savedArticles: "tb_public_web_content_push_intent_v2:saved_articles",
});

let tokenSequence = 0;

function newIntentToken() {
  tokenSequence = (tokenSequence + 1) % Number.MAX_SAFE_INTEGER;
  let random = "";
  try {
    random = crypto.randomUUID();
  } catch {
    random = Math.random().toString(36).slice(2);
  }
  return `${Date.now().toString(36)}.${tokenSequence.toString(36)}.${random}`;
}

function normalizedToken(value) {
  const token = String(value || "").trim();
  return token && token.length <= 240 ? token : null;
}

export function emptyContentPushIntentReceipt() {
  return {
    version: 2,
    tasksToken: null,
    savedArticlesToken: null,
  };
}

export function readContentPushIntent(io) {
  try {
    return {
      version: 2,
      tasksToken: normalizedToken(io?.read?.("tasks")),
      savedArticlesToken: normalizedToken(io?.read?.("savedArticles")),
    };
  } catch {
    return emptyContentPushIntentReceipt();
  }
}

/**
 * Each domain owns an independent unique token. There is no shared JSON
 * read-modify-write, so task and article tabs cannot overwrite one another.
 */
export function markContentPushIntentSync(io, options = {}) {
  if (options.includeTasks) io.write("tasks", newIntentToken());
  if (options.includeSavedArticles) {
    io.write("savedArticles", newIntentToken());
  }
  return readContentPushIntent(io);
}

export function pendingContentPushOptions(io) {
  const receipt = readContentPushIntent(io);
  return {
    ...(receipt.tasksToken ? { includeTasks: true } : {}),
    ...(receipt.savedArticlesToken ? { includeSavedArticles: true } : {}),
  };
}

function acknowledgeDomain(io, domain, receiptToken) {
  const expected = normalizedToken(receiptToken);
  if (!expected) return;
  const current = normalizedToken(io.read(domain));
  if (current === expected) io.remove(domain);
}

export function acknowledgeContentPushIntentSync(io, receipt, pushedOptions = {}) {
  if (pushedOptions.includeTasks) {
    acknowledgeDomain(io, "tasks", receipt?.tasksToken);
  }
  if (pushedOptions.includeSavedArticles) {
    acknowledgeDomain(io, "savedArticles", receipt?.savedArticlesToken);
  }
  return readContentPushIntent(io);
}
